import script from "./AvatarPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarPicker.vue?vue&type=script&setup=true&lang=js"

import "./AvatarPicker.vue?vue&type=style&index=0&id=802e56da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-802e56da"]])

export default __exports__